import React from "react";

import styles from "./styles.module.scss";

/**
 * Every version this user accepted before the one they hold now, newest first,
 * one per row.
 *
 * A list rather than a sentence: a user who has been on the platform through
 * several revisions accumulates as many rows, and a comma-separated run of them
 * is unreadable long before it is complete.
 */
const PreviousTerms = ({ customProps }) => {
    const { email, entries } = customProps;
    return (
        <div className={styles.previousTerms}>
            <div className={styles.previousTermsTitle}>
                Previously accepted &middot; {email}
            </div>
            <table className={styles.table}>
                <thead>
                    <tr>
                        <th>Version</th>
                        <th>Accepted</th>
                    </tr>
                </thead>
                <tbody>
                    {entries.map((entry) => (
                        <tr key={entry.version}>
                            <td>{entry.version}</td>
                            <td>{entry.accepted}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default PreviousTerms;
